import jwt_decode from 'jwt-decode'
import { AuthStorage } from '../../utils'
import { AgentPayload } from '@backend/authorization/types'

// TODO: Work on it on Auth ticket

export function useAuthToken() {
  function getAccessTokenPayload(): AgentPayload | null {
    const accessToken = AuthStorage.getAccessToken()

    if (!accessToken) return null
    try {
      return jwt_decode(accessToken) as AgentPayload
    } catch (e) {
      return null
    }
  }

  function isActiveSession(): boolean {
    const tokenPayload = getAccessTokenPayload()
    if (!tokenPayload?.exp) return false
    return Date.now() < tokenPayload.exp * 1000
  }

  function isRefreshableSession(): boolean {
    return !!AuthStorage.getRefreshToken()
  }

  return {
    isRefreshableSession,
    getAccessTokenPayload,
    isActiveSession,
  }
}
